import axios from "axios";
import { apiUrl } from "../api/config";
import ILoginCredentials from "../interfaces/ILoginCredentials";
import ITokenPayload from "../interfaces/ITokenPayload";

export default class AuthService {
    async login(credentials: ILoginCredentials): Promise<ITokenPayload> {
        try {
            const response = await axios.post<ITokenResponse>(apiUrl + "/token", {
                grant_type: "password",
                username: credentials.login,
                password: credentials.password,
                client_id: "1",
            }, {
                headers: {
                    "Content-Type": "application/x-www-form-urlencoded",
                },
            });

            return {
                access_token: response.data.access_token,
                email: response.data.userEmail,
                expires_in: response.data.expires_in,
                refresh_token: response.data.refresh_token,
                token_type: response.data.token_type,
            };
        } catch (error: any) {
            if (error.response?.data?.error)
                throw error.response.data.error;

            throw new Error();
        }
    }

    async refreshToken(refreshToken: string): Promise<ITokenPayload> {
        try {
            const response = await axios.post<ITokenResponse>(apiUrl + "/token", {
                grant_type: "refresh_token",
                refresh_token: refreshToken,
                client_id: "1",
            }, {
                headers: {
                    "Content-Type": "application/x-www-form-urlencoded",
                },
            });

            return {
                access_token: response.data.access_token,
                email: response.data.userEmail,
                expires_in: response.data.expires_in,
                refresh_token: response.data.refresh_token,
                token_type: response.data.token_type,
            };
        } catch (error: any) {
            if (error.response?.data?.error)
                throw error.response.data.error;

            throw new Error();
        }
    };
}

interface ITokenResponse {
    access_token: string;
    token_type: string;
    expires_in: number;
    refresh_token: string;
    userEmail: string;
}